// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-apps-js": () => import("/Users/xvision/React/xvisionSite/src/pages/apps.js" /* webpackChunkName: "component---src-pages-apps-js" */),
  "component---src-pages-index-js": () => import("/Users/xvision/React/xvisionSite/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-js": () => import("/Users/xvision/React/xvisionSite/src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-pages-support-js": () => import("/Users/xvision/React/xvisionSite/src/pages/support.js" /* webpackChunkName: "component---src-pages-support-js" */)
}

